import { useEffect, useState } from "react";
import { getFileUrl } from "@/lib/supabaseOps";

export function useSupabaseFileUrl(payload, bucket) {
  const [resolvedUrl, setResolvedUrl] = useState(payload?.dataUrl || "");

  useEffect(() => {
    let active = true;

    if (payload?.dataUrl) {
      setResolvedUrl(payload.dataUrl);
      return () => {
        active = false;
      };
    }

    if (!payload?.filePath || !bucket) {
      setResolvedUrl("");
      return () => {
        active = false;
      };
    }

    getFileUrl(bucket, payload.filePath)
      .then((url) => {
        if (active) {
          setResolvedUrl(url);
        }
      })
      .catch((error) => {
        console.error(error);
        if (active) {
          setResolvedUrl("");
        }
      });

    return () => {
      active = false;
    };
  }, [payload?.dataUrl, payload?.filePath, bucket]);

  return resolvedUrl;
}
